const subscriptions = [
  {
    id: 'basic',
    title: 'Basic Puja Plan',
    price: '₹499',
    period: '/mo',
    features: [
      'Fresh Marigold & Loose Petals',
      'Early Morning 7:00 AM Delivery'
    ],
    badge: null
  },
  {
    id: 'premium',
    title: 'Premium Daily + Garland',
    price: '₹999',
    period: '/mo',
    features: [
      'Exotic Flowers & Jasmine Strings',
      'Weekly Fresh Small Garland',
      'Priority Doorstep Service'
    ],
    badge: 'Best Value'
  },
  {
    id: 'elite',
    title: 'Elite Festival Plus',
    price: '₹1,999',
    period: '/mo',
    features: [
      'Premium Daily Variety',
      'Full Festival Kits Included',
      'Priority Early Morning Delivery'
    ],
    badge: null
  }
];

export default subscriptions;
